module.exports = __webpack_public_path__ + "dffb37a0bb01626e43c30095a6ebce7d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/icomoon.ttf
// module id = 408
// module chunks = 0